function flattenPermissions(list, result = []) {
  if (!Array.isArray(list)) return result
  list.forEach((item) => {
    if (!item) return
    result.push(item)
    flattenPermissions(item.children, result)
  })
  return result
}

export function getUserPermissions(userInfo) {
  return flattenPermissions((userInfo && userInfo.permissions) || [])
}

export function getUserPermissionCodes(userInfo) {
  return getUserPermissions(userInfo)
    .map((item) => String((item && item.permissionCode) || '').trim())
    .filter(Boolean)
}

export function hasPermissionCode(userInfo, permissionCode) {
  if (!permissionCode) return true
  return getUserPermissionCodes(userInfo).includes(permissionCode)
}

export function hasAnyPermissionCode(userInfo, permissionCodes) {
  const codes = Array.isArray(permissionCodes) ? permissionCodes : [permissionCodes]
  return codes.some((code) => hasPermissionCode(userInfo, code))
}

// 菜单级鉴权：只要该模块下有任意一条权限（菜单节点或其下按钮节点）即放行
export function hasModulePermission(userInfo, permissionModule) {
  if (!permissionModule) return true
  const modules = Array.isArray(permissionModule) ? permissionModule : [permissionModule]
  const codes = getUserPermissionCodes(userInfo)
  return modules.some((moduleKey) =>
    codes.some(
      (code) =>
        code === moduleKey ||
        code === `${moduleKey}-menu` ||
        code.startsWith(`${moduleKey}:`)
    )
  )
}

export function hasPermissionName(userInfo, permissionNames) {
  const names = Array.isArray(permissionNames) ? permissionNames : [permissionNames]
  return getUserPermissions(userInfo).some((item) =>
    names.includes(item.permissionName)
  )
}

export function hasRoutePermission(userInfo, meta) {
  if (!meta) return true
  if (meta.permissionCode) {
    return hasPermissionCode(userInfo, meta.permissionCode)
  }
  if (meta.permissionCodes) {
    return hasAnyPermissionCode(userInfo, meta.permissionCodes)
  }
  if (meta.permissionModule) {
    return hasModulePermission(userInfo, meta.permissionModule)
  }
  if (meta.permissionName) {
    return hasPermissionName(userInfo, meta.permissionName)
  }
  return true
}
